import usePrivateAxios from '@/common/api/usePrivateAxios';
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant';
import { BulkActionGlobalColumnsValidationSchema } from '@/common/schemas/bulkActions/globalColumns.schema';
import { Mapper } from '@/common/services/mapper';
import { MetaResponse } from '@/common/types/metaResponse';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

type UseBulkActionsEntriesMineProps<T> = {
  filters?: {
    actionerKlass?: string;
    status?: string;
    createdAtStartDate?: string;
    createdAtEndDate?: string;
    globalColumns?: BulkActionGlobalColumnsValidationSchema;
  };
  mapper?: (data: any) => T;
};

export const useBulkActionsEntriesMine = <T,>({
  filters: { actionerKlass, status, createdAtStartDate, createdAtEndDate, globalColumns } = {},
  mapper = Mapper.default<T>(),
}: UseBulkActionsEntriesMineProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    enabled: !!actionerKlass,
    queryKey: ['bulkActionsEntriesMine', actionerKlass, status, createdAtStartDate, createdAtEndDate, ...(globalColumns ? Object.values(globalColumns) : [])],
    queryFn: () => {
      return privateAxios.post('/bulk_actions/entries/mine', {
        q: {
          actioner_klass_eq: actionerKlass,
          status_eq: status,
          created_at_gteq: createdAtStartDate,
          created_at_lteq: createdAtEndDate,
        },
        options_includes: {
          global_columns: globalColumns,
        },
      });
    },
    select: (data: { data: { data: any[]; meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
    refetchInterval: 60000,
  });

  return { data, meta, ...rest };
};
